<template>
    <section class="tables landing-page">
        <vue-snotify></vue-snotify>
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">View Documents</h4>
                    </div>
                    <div class="card-body">
                        <form action="" @submit.prevent="" method="post">
                            <div class="row">
                                <div class="col-lg-3 col-md-4 col-sm-6">
                                    <div role="group" class="form-group">
                                        <div>
                                            <input id="search" name="search" v-model.trim="searchIndex" type="text"
                                                placeholder="Search" @keyup="searchFn" @keydown="searchFn"
                                                class="form-control form-control-sm">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div style="overflow: auto">
                            <CircleLoader v-if="isLoading" />
                            <table class="table">
                                <thead class=" table-dark">
                                    <tr>
                                        <th scope="col">Name</th>
                                        <th scope="col">Description</th>
                                        <th scope="col">Module Name</th>
                                        <th scope="col">Week Name</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody v-for="doc in allDocument" :key="doc.DocID">
                                    <tr v-if="shouldShowHeading(doc.ModuleID)">
                                        <th class="text-center" colspan="5">
                                            <h4>Module {{ doc.ModuleNumber }} - {{ doc.ModuleName }}</h4>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th scope="row">{{ doc.DocName }}</th>
                                        <td>{{ doc.DocDescription }}</td>
                                        <td>{{ doc.ModuleName }}</td>
                                        <td>{{ doc.WeekName }}</td>
                                        <td><button @click="editRedirect(doc)" class="btn btn-sm btn-primary">Edit</button></td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>
</template>

<script>

import Vue from "vue";
import API from "@/api";
import jsPDF from 'jspdf';

Vue.use(jsPDF)

export default {
    data() {
        return {
            isLoading: false,
            allDocument: {},
            searchTime: null,
            searchIndex: "",
        }
    },
    methods: {
        searchFn() {
            clearTimeout(this.searchTime);
            this.searchTime = setTimeout(() => {
                this.getAllDocuments();
            }, 1000)
        },
        getAllDocuments() {

            API.getAllDocuments({ search: this.searchIndex }, this.getAllDocumentsCB, this.errorCB);
        },
        getAllDocumentsCB(res) {
            this.allDocument = res.data;
            this.isLoading = false;
        },
        shouldShowHeading(id) {
            if (id === this.currentModuleId) {
                return false; // Hide the heading if the module ID is the same as the currentModuleId
            } else {
                this.changeCurrentId(id);
                return true; // Show the heading if the module ID is different from the currentModuleId
            }
        },
        changeCurrentId(id) {
            this.currentModuleId = id;
        },
        editRedirect(data) {
            this.$router.push({ name:"edit_document", params:{id:data.document_id,document:data }});

        },
        errorCB(err) {
            console.log(err);
            this.$showNotification({ message: "Failed system error" }, 'error')
        },
    },
    mounted() {
        this.isLoading = true;
        this.getAllDocuments()
    },
    components: {}
}

</script>